import Dispatch from '../Dispatch/Dispatch';

function triggerDispatch(attr) {
	switch(attr) {
	case 'selectedSeries':
		Dispatch.dispatch.call('selectedSeriesUpdate');
		break;

	case 'highlightedCountry':
		Dispatch.dispatch.call('highlightedCountryUpdate');
		break;

	case 'hoveredCountry':
		Dispatch.dispatch.call('hoveredCountryUpdate');
		break;

	case 'includeIndirectDeaths':
		Dispatch.dispatch.call('includeIndirectDeathsUpdate');
		break;

	case 'includeStunting':
		Dispatch.dispatch.call('includeStuntingUpdate');
		break;

	case 'dalysByRate':
		Dispatch.dispatch.call('dalysByRateUpdate');
		break;

	default:
		break;
	}
}


var api = {
	selectedSeries: 'cases',
	highlightedCountry: null,
	hoveredCountry: null,

	includeIndirectDeaths: false,
	includeStunting: false,
	dalysByRate: false,

	set: function(attr, value) {
		api[attr] = value;

		triggerDispatch(attr);
	}
};

export default api;




/** WEBPACK FOOTER **
 ** ./src/State/State.js
 **/